<!-- 处方、健康辅助方卡片上的标签 -->
<template>
  <div class="statusImgs">
    <a-image :preview="false" :src="getImg" />
  </div>
</template>
<script>
import { getStatusLabel } from '@/utils'
export default {
  name: 'CourseStatus',
  props: {
    info: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    getImg() {
      try {
        const { buyFlag, invalid, expireStatus } = this.info
        return this.getStatusLabel({
          status: buyFlag,
          expire: expireStatus,
          invalid
        }).chatImage
      } catch (error) {
        return ''
      }
    }
  },
  methods: {
    getStatusLabel
  }
}
</script>
<style lang="scss" scoped>
.statusImgs {
  position: absolute;
  top: 5px;
  right: 20px;
  z-index: 1;
  width: 58px;
}
</style>
